import React from 'react';

export default function Grid({ children, variant }) {
  return <div className={`docpro_grid ${variant}`}>{children}</div>;
}
